import { FormEvent, useContext, useEffect, useState } from "react"
import { toast } from "react-toastify"
import { GrupoLista, permissao } from "../../interfaces/grupos"
import { atualizarPermissao, listarGrupos } from "../../services/grupos"
import { BiPencil } from "react-icons/bi"
import { ModalEstadoContext } from "../../contexts/ModalEstado"
import { criptografarDado, descriptografarDado } from "../../helpers"
import { useModulosContratados } from "../../middleware/SistemasContratados"
import Permissoes from "../../middleware/Permissoes"
import ModalGrupo from "../ModalGrupo"
import ModalTransferenciaGrupo from "../ModalTransferenciaGrupo"
import DivSituacao from "../DivSituacao"
import FiltrosDefault from "../FiltrosDefault"
import Toggle from "../ToogleDafault"
import NenhumResultadoEncontrado from "../NenhumResultadoEncontrato"
import "../../styles/configuracoes.css"
import "../../styles/gruposPermissoes.css"

function GruposPermissoes() {
    const { modal, atualizarDados, modalExibir, atualizarInformacoes, modalSecundario } = useContext(ModalEstadoContext)
    const organizacaoLogada = localStorage.getItem("organizacaoGesttor")

    const [processando, setProcessando] = useState(false);

    const [titulo, setTitulo] = useState("")
    const [situacao, setSituacao] = useState("")

    const [grupos, setGrupos] = useState<GrupoLista[]>([]);
    const [grupoSelecionado, setGrupoSelecionado] = useState<GrupoLista>();

    const [nenhumResultado, setNenhumResultado] = useState(false)

    const buscarGrupos = async (e?: FormEvent) => {

        e?.preventDefault()
        setNenhumResultado(false)
        try {
            const resposta = await listarGrupos({ titulo, situacao })
            if (!resposta.data || resposta.data.length === 0) {
                setNenhumResultado(true)
            }

            if (resposta.status === 200 && resposta.data !== null) {
                setGrupos(resposta.data)
            }

            return

        } catch {
            toast.error("Erro ao buscar os Grupos.")
        }
    }

    const permissoesFixas = [
        {
            Dashboard: [
                {
                    permissao: "dashboard_acesso",
                    titulo: "Acesso ao Dashboard",
                    descricao: "Com esta permissão o usuário terá acesso ao menu do dashboard",
                },
                {
                    permissao: "dashboard_geral",
                    titulo: "Acesso ao Dashboard Geral",
                    descricao: "Com esta permissão o usuário terá acesso ao painel com as principais estatísticas da organização",
                },
                {
                    permissao: "dashboard_financeiro",
                    titulo: "Acesso ao Dashboard Financeiro",
                    descricao: "Com esta permissão o usuário terá acesso ao painel com as principais estatísticas financeiras da organização",
                },
                {
                    permissao: "dashboard_processo_seletivo",
                    titulo: "Acesso ao Dashboard de Processo Seletivo",
                    descricao: "Com esta permissão o usuário terá acesso ao painel com as principais estatísticas dos recrutamentos da entidade",
                },
                {
                    permissao: "dashboard_banco_talentos",
                    titulo: "Acesso ao Dashboard de Banco de Talentos",
                    descricao: "Com esta permissão o usuário terá acesso ao painel com as principais estatísticas dos candidatos inscritos no banco de talentos",
                },
                {
                    permissao: "dashboard_meu_painel",
                    titulo: "Meu Painel",
                    descricao: "Com esta permissão o usuário terá acesso ao painel com as principais estatísticas sobre a sua produtividade dentro da unidade",
                },
            ]
        },
        {
            Atendimento: [
                {
                    permissao: "atendimento_acesso",
                    titulo: "Acesso ao Atendimento",
                    descricao: "Com esta permissão o usuário terá acesso ao menu de atendimento da plataforma",
                },
                {
                    permissao: "atendimento_lead",
                    titulo: "Leads",
                    descricao: "Com esta permissão o usuário terá acesso ao submenu dos leads da plataforma",
                },
                {
                    permissao: "atendimento_lead_cadastrar",
                    titulo: "Cadastrar Lead",
                    descricao: "Com esta permissão o usuário poderá inserir novos leads na plataforma",
                },
                {
                    permissao: "atendimento_lead_atualizar",
                    titulo: "Atualizar Lead",
                    descricao: "Com esta permissão o usuário poderá atualizar dados cadastrais de um lead da plataforma",
                },
                {
                    permissao: "atendimento_lead_apagar",
                    titulo: "Apagar Lead",
                    descricao: "Com esta permissão o usuário poderá excluir um lead previamente cadastrado na plataforma",
                },
                {
                    permissao: "lead_filtro_avancado",
                    titulo: "Filtros Avançados no Lead",
                    descricao: "Com esta permissão usuário tem acesso aos filtros avançados dos leads na plataforma, podendo filtrar pela empresa, responsável ou solicitante",
                },
                {
                    permissao: "atendimento_contato",
                    titulo: "Contatos",
                    descricao: "Com esta permissão o usuário terá acesso ao submenu dos contatos da plataforma",
                },
                {
                    permissao: "atendimento_contato_cadastrar",
                    titulo: "Cadastrar Contato",
                    descricao: "Com esta permissão o usuário poderá cadastrar novos contatos na plataforma",
                },
                {
                    permissao: "atendimento_contato_atualizar",
                    titulo: "Atualizar Contato",
                    descricao: "Com esta permissão o usuário poderá atualizar dados cadastrais de um contato na plataforma",
                },
                {
                    permissao: "atendimento_contato_apagar",
                    titulo: "Apagar Contato",
                    descricao: "Com esta permissão o usuário excluir contatos da plataforma",
                },
                {
                    permissao: "atendimento_contato_vincular",
                    titulo: "Vincular Contato",
                    descricao: "Com esta permissão o usuário poderá vincular contatos a clientes vindos da plataforma Zai Chat",
                },
                {
                    permissao: "atendimento_contato_tag",
                    titulo: "Visualizar Tags",
                    descricao: "Com esta permissão o usuário poderá visualizar as tags vinculadas a um contato",
                },
                {
                    permissao: "atendimento_contato_tag_cadastrar",
                    titulo: "Cadastrar Tags",
                    descricao: "Com esta permissão o usuário poderá cadastrar novas tags na plataforma",
                },
                {
                    permissao: "atendimento_contato_remover_tag",
                    titulo: "Remover Tags",
                    descricao: "Com esta permissão o usuário poderá remover as tags na plataforma",
                },
                {
                    permissao: "atendimento_comunicado",
                    titulo: "Comunicados",
                    descricao: "Com esta permissão o usuário terá acesso ao submenu dos comunicados na plataforma",
                },
                {
                    permissao: "atendimento_comunicado_cadastrar",
                    titulo: "Cadastrar Comunicado",
                    descricao: "Com esta permissão o usuário poderá inserir comunicados na plataforma",
                },
                {
                    permissao: "atendimento_comunicado_cancelar",
                    titulo: "Cancelar Comunicado",
                    descricao: "Com esta permissão o usuário poderá cancelar um comunicado agendado",
                },
            ]
        },
        {
            Tarefas: [
                {
                    permissao: "tarefas_recorrentes",
                    titulo: "Tarefas Recorrentes",
                    descricao: "Com esta permissão o usuário terá acesso ao submenu das tarefas recorrentes",
                },
                {
                    permissao: "tarefas_visao_geral",
                    titulo: "Visão Geral",
                    descricao: "Com esta permissão o usuário poderá visualizar as tarefas de todos os membros",
                },
                {
                    permissao: "tarefas_cadastrar",
                    titulo: "Cadastrar Tarefa",
                    descricao: "Com esta permissão o usuário poderá inserir novas tarefas na plataforma",
                },
                {
                    permissao: "tarefas_apagar",
                    titulo: "Apagar Tarefa",
                    descricao: "Com esta permissão o usuário poderá apagar uma tarefa da plataforma",
                },
                {
                    permissao: "tarefas_prazo_entrega",
                    titulo: "Alterar Prazo",
                    descricao: "Com esta permissão o usuário poderá alterar o prazo de entrega de uma tarefa",
                },
            ]
        },
        {
            Processos: [
                {
                    permissao: "processo_acesso",
                    titulo: "Acesso aos Processos",
                    descricao: "Com esta permissão o usuário terá acesso ao menu de processos da plataforma",
                },
                {
                    permissao: "processo_todos",
                    titulo: "Todos os Processos",
                    descricao: "Com esta permissão o usuário poderá visualizar todos os processos da plataforma, inclusive de outros usuários.",
                },
                {
                    permissao: "processo_cadastrar",
                    titulo: "Cadastrar Processo",
                    descricao: "Com esta permissão o usuário poderá inserir novos processos na plataforma.",
                },
                {
                    permissao: "processo_atualizar",
                    titulo: "Atualizar Processo",
                    descricao: "Com esta permissão o usuário poderá atualizar os dados cadastrais de um processo na plataforma.",
                },
                {
                    permissao: "processo_modelos",
                    titulo: "Modelos de Processos",
                    descricao: "Com esta permissão o usuário poderá visualizar os modelos de processos cadastrados na plataforma.",
                },
                {
                    permissao: "processo_modelos_atualizar",
                    titulo: "Atualizar Modelo",
                    descricao: "Com esta permissão o usuário poderá atualizar um modelo de processo na plataforma, podendo adicionar novas tarefas ou atualizar uma tarefa já existente.",
                },
                {
                    permissao: "processo_template",
                    titulo: "Acessar Templates de Processo",
                    descricao: "Com esta permissão o usuário poderá visualizar os tamplets de processos da plataforma.",
                },
                {
                    permissao: "processo_template_cadastrar",
                    titulo: "Cadastrar Template de Processo",
                    descricao: "Com esta permissão o usuário poderá inserir novos tamplets na plataforma.",
                },
                {
                    permissao: "processo_template_atualizar",
                    titulo: "Atualizar Template de Processo",
                    descricao: "Com esta permissão o usuário poderá atualizar informações cadastrais de um template, inclusive adicionar novas tarefas, atualizar tarefas de um template ou remover tarefas.",
                },
            ]
        },
        {
            Recrutamento: [
                {
                    permissao: "recrutamento_acesso",
                    titulo: "Acesso ao Recrutamento",
                    descricao: "Com esta permissão o usuário terá acesso ao menu do recrutamento na plataforma",
                },
                {
                    permissao: "recrutamento_todos",
                    titulo: "Todos os Recrutamentos",
                    descricao: "Com esta permissão o usuário poderá listar todos os recrutamentos da plataforma",
                },
                {
                    permissao: "recrutamento_meus",
                    titulo: "Meus Recrutamentos",
                    descricao: "Com esta permissão o usuário terá acesso ao submenu dos meus recrutamentos",
                },
                {
                    permissao: "recrutamento_nps",
                    titulo: "NPS",
                    descricao: "Com esta permissão o usuário terá acesso ao submenu de NPS dos processos seletivos",
                },
                {
                    permissao: "recrutamento_disc",
                    titulo: "Questionário DISC",
                    descricao: "Com esta permissão o usuário terá acesso ao questionário DISC",
                },
                {
                    permissao: "recrutamento_banco_talentos",
                    titulo: "Banco de Talentos",
                    descricao: "Com esta permissão o usuário poderá acessar o banco de talentos",
                },
                {
                    permissao: "recrutamento_cadastrar",
                    titulo: "Cadastrar Recrutamento",
                    descricao: "Com esta permissão o usuário poderá cadastrar novos processos seletivos",
                },
                {
                    permissao: "recrutamento_atualizar",
                    titulo: "Atualizar Recrutamento",
                    descricao: "Com esta permissão o usuário poderá atualizar dados cadastrais de um processo seletivo",
                },
            ]
        },
        {
            Projetos: [
                {
                    permissao: "projeto_acesso",
                    titulo: "Acesso aos projetos",
                    descricao: "Com esta permissão o usuário terá acesso ao menu dos projetos na plataforma",
                },
                {
                    permissao: "projeto_todos",
                    titulo: "Todos os projetos",
                    descricao: "Com esta permissão o usuário terá acesso ao submenu de todos os projetos",
                },
                {
                    permissao: "projeto_meus",
                    titulo: "Meus projetos",
                    descricao: "Com esta permissão o usuário terá acesso ao submenu dos meus projetos",
                },
                {
                    permissao: "projeto_banco_indicadores",
                    titulo: "Banco de indicadores",
                    descricao: "Com esta permissão o usuário poderá acessar o banco de indicadores",
                },
                {
                    permissao: "projeto_cadastrar",
                    titulo: "Cadastrar projeto",
                    descricao: "Com esta permissão o usuário poderá cadastrar novos projetos",
                },
                {
                    permissao: "projeto_atualizar",
                    titulo: "Atualizar projeto",
                    descricao: "Com esta permissão o usuário poderá atualizar dados de um projeto",
                },
                {
                    permissao: "projeto_cadastrar_membros",
                    titulo: "Cadastrar membros",
                    descricao: "Com esta permissão o usuário poderá vincular novos membros ao projeto",
                },
                {
                    permissao: "projeto_remover_membros",
                    titulo: "Remover membros",
                    descricao: "Com esta permissão o usuário poderá remover um usuário do projeto",
                },
            ]
        },
        {
            Cadastros: [
                {
                    permissao: "cadastro_acesso",
                    titulo: "Acesso aos cadastros",
                    descricao: "Com esta permissão o usuário terá acesso ao menu de cadastros",
                },
                {
                    permissao: "cadastro_cliente",
                    titulo: "Clientes",
                    descricao: "Com esta permissão o usuário terá acesso ao submenu de clientes",
                },
                {
                    permissao: "cadastro_responsavel",
                    titulo: "Responsáveis",
                    descricao: "Com esta permissão o usuário terá acesso ao submenu de responsáveis",
                },
                {
                    permissao: "cadastro_colaborador",
                    titulo: "Colaboradores",
                    descricao: "Com esta permissão o usuário terá acesso ao submenu de colaboradores",
                },
                {
                    permissao: "cadastro_fornecedor",
                    titulo: "Fornecedores",
                    descricao: "Com esta permissão o usuário terá acesso ao submenu de fornecedores",
                },
                {
                    permissao: "cadastro_inserir",
                    titulo: "Inserir cadastro",
                    descricao: "Com esta permissão o usuário poderá inserir novos cadastros",
                },
                {
                    permissao: "cadastro_atualizar",
                    titulo: "Atualizar cadastro",
                    descricao: "Com esta permissão o usuário poderá atualizar dados cadastrais",
                },
            ]
        },
        {
            Financeiro: [
                {
                    permissao: "financeiro_acesso",
                    titulo: "Acesso ao Financeiro",
                    descricao: "Com esta permissão o usuário terá acesso ao menu financeiro",
                },
                {
                    permissao: "financeiro_assinatura",
                    titulo: "Assinaturas",
                    descricao: "Com esta permissão o usuário terá acesso ao submenu de assinaturas",
                },
                {
                    permissao: "financeiro_receita",
                    titulo: "Receitas",
                    descricao: "Com esta permissão o usuário terá acesso ao submenu de receitas",
                },
                {
                    permissao: "financeiro_despesa",
                    titulo: "Despesas",
                    descricao: "Com esta permissão o usuário terá acesso ao submenu de despesas",
                },
                {
                    permissao: "financeiro_despesa_recorrente",
                    titulo: "Despesas Recorrentes",
                    descricao: "Com esta permissão o usuário terá acesso ao submenu de despesas recorrentes",
                },
                {
                    permissao: "financeiro_clientes_inadimplentes",
                    titulo: "Clientes Inadimplentes",
                    descricao: "Com esta permissão o usuário terá acesso aos clientes inadimplentes",
                },
                {
                    permissao: "financeiro_contas",
                    titulo: "Contas Bancárias",
                    descricao: "Com esta permissão o usuário terá acesso ao submenu de contas bancárias",
                },
                {
                    permissao: "financeiro_assinatura_cadastrar",
                    titulo: "Cadastrar Assinatura",
                    descricao: "Com esta permissão o usuário poderá cadastrar novas assinaturas",
                },
                {
                    permissao: "financeiro_assinatura_atualizar",
                    titulo: "Atualizar Assinatura",
                    descricao: "Com esta permissão o usuário poderá atualizar uma assinatura",
                },
                {
                    permissao: "financeiro_receita_cadastrar",
                    titulo: "Cadastrar Receita",
                    descricao: "Com esta permissão o usuário poderá cadastrar novas receitas",
                },
                {
                    permissao: "financeiro_receita_atualizar",
                    titulo: "Atualizar Receita",
                    descricao: "Com esta permissão o usuário poderá atualizar uma receita",
                },
                {
                    permissao: "financeiro_receita_recebimento",
                    titulo: "Baixar Recebimento",
                    descricao: "Com esta permissão o usuário poderá baixar um recebimento manualmente",
                },
                {
                    permissao: "financeiro_receita_cobranca",
                    titulo: "Gerar Cobrança",
                    descricao: "Com esta permissão o usuário poderá gerar cobranças",
                },
                {
                    permissao: "financeiro_receita_cobranca_cancelar",
                    titulo: "Cancelar Cobrança",
                    descricao: "Com esta permissão o usuário poderá cancelar cobranças",
                },
                {
                    permissao: "financeiro_despesa_cadastrar",
                    titulo: "Cadastrar Despesa",
                    descricao: "Com esta permissão o usuário poderá cadastrar despesas",
                },
                {
                    permissao: "financeiro_despesa_atualizar",
                    titulo: "Atualizar Despesa",
                    descricao: "Com esta permissão o usuário poderá atualizar despesas",
                },
                {
                    permissao: "financeiro_despesa_pagamento",
                    titulo: "Pagar Despesa",
                    descricao: "Com esta permissão o usuário poderá realizar pagamento manual",
                },
                {
                    permissao: "financeiro_despesa_recorrente_cadastrar",
                    titulo: "Cadastrar Despesa Recorrente",
                    descricao: "Com esta permissão o usuário poderá cadastrar despesas recorrentes",
                },
                {
                    permissao: "financeiro_despesa_recorrente_atualizar",
                    titulo: "Atualizar Despesa Recorrente",
                    descricao: "Com esta permissão o usuário poderá atualizar despesa recorrente",
                },
                {
                    permissao: "financeiro_contas_cadastrar",
                    titulo: "Cadastrar Conta",
                    descricao: "Com esta permissão o usuário poderá cadastrar contas bancárias",
                },
                {
                    permissao: "financeiro_contas_atualizar",
                    titulo: "Atualizar Conta",
                    descricao: "Com esta permissão o usuário poderá atualizar contas bancárias",
                },
                {
                    permissao: "financeiro_contas_transferencia",
                    titulo: "Transferência entre Contas",
                    descricao: "Com esta permissão o usuário poderá realizar transferências",
                },
            ]
        },
        {
            Documentos: [
                {
                    permissao: "doc_acesso",
                    titulo: "Acesso aos Documentos",
                    descricao: "Com esta permissão o usuário terá acesso ao menu de documentos",
                },
                {
                    permissao: "doc_contrato",
                    titulo: "Contratos",
                    descricao: "Com esta permissão o usuário terá acesso ao submenu de contratos",
                },
                {
                    permissao: "doc_contrato_cadastrar",
                    titulo: "Cadastrar Contrato",
                    descricao: "Com esta permissão o usuário poderá cadastrar novos contratos",
                },
                {
                    permissao: "doc_assinatura",
                    titulo: "Assinaturas",
                    descricao: "Com esta permissão o usuário terá acesso ao submenu de assinaturas",
                },
                {
                    permissao: "doc_cadastrar",
                    titulo: "Cadastrar Assinatura",
                    descricao: "Com esta permissão o usuário poderá cadastrar solicitações de assinatura",
                },
                {
                    permissao: "doc_cancelar",
                    titulo: "Cancelar Assinatura",
                    descricao: "Com esta permissão o usuário poderá cancelar uma solicitação",
                },
                {
                    permissao: "doc_solicitacoes",
                    titulo: "Todas as Solicitações",
                    descricao: "Com esta permissão o usuário poderá visualizar todas as solicitações",
                },
                {
                    permissao: "doc_modelo_contrato",
                    titulo: "Modelos de Contrato",
                    descricao: "Com esta permissão o usuário terá acesso aos modelos de contrato",
                },
                {
                    permissao: "doc_modelo_contrato_cadastrar",
                    titulo: "Cadastrar Modelo",
                    descricao: "Com esta permissão o usuário poderá cadastrar modelos de contrato",
                },
                {
                    permissao: "doc_modelo_contrato_atualizar",
                    titulo: "Atualizar Modelo",
                    descricao: "Com esta permissão o usuário poderá atualizar modelos de contrato",
                },
            ]
        },
        {
            "Relatórios": [
                {
                    permissao: "relatorio_acesso",
                    titulo: "Acesso aos Relatórios",
                    descricao: "Com esta permissão o usuário terá acesso ao menu de relatórios",
                },
                {
                    permissao: "relatorio_dre",
                    titulo: "Relatório DRE",
                    descricao: "Com esta permissão o usuário terá acesso ao relatório de demonstração de resultado",
                },
                {
                    permissao: "relatorio_dfc",
                    titulo: "Relatório DFC",
                    descricao: "Com esta permissão o usuário terá acesso ao relatório de fluxo de caixa",
                },
            ]
        },
        {
            Conquistas: [
                {
                    permissao: "conquistas_acesso",
                    titulo: "Acesso as Conquistas",
                    descricao: "Com esta permissão o usuário terá acesso ao menu das conquistas",
                },
                {
                    permissao: "conquistas_conquista",
                    titulo: "Conquistas",
                    descricao: "Com esta permissão o usuário poderá gerenciar as conquistas, adicionanodo ou atualizando os dados",
                },
                {
                    permissao: "conquistas_recompensa",
                    titulo: "Recompensas",
                    descricao: "Com esta permissão o usuário poderá gerenciar as solicitações das recompensas",
                },
            ]
        },
        {
            Gesttor: [
                {
                    permissao: "gesttor_acesso",
                    titulo: "Acesso ao Gesttor",
                    descricao: "Com esta permissão o usuário terá acesso ao menu gesttor",
                },
                {
                    permissao: "gesttor_licenca",
                    titulo: "Gerenciar Licenças",
                    descricao: "Com esta permissão o usuário poderá gerenciar licenças",
                },
                {
                    permissao: "gesttor_atendimento",
                    titulo: "Solicitações de Atendimento",
                    descricao: "Com esta permissão o usuário terá acesso às solicitações de atendimento",
                },
                {
                    permissao: "gesttor_suporte",
                    titulo: "Bugs Reportados",
                    descricao: "Com esta permissão o usuário terá acesso aos bugs reportados",
                },
                {
                    permissao: "gesttor_melhoria",
                    titulo: "Sugestões de Melhoria",
                    descricao: "Com esta permissão o usuário terá acesso às sugestões de melhoria",
                },
                {
                    permissao: "gesttor_recompensa",
                    titulo: "Solicitações de Recompensa",
                    descricao: "Com esta permissão usuário tem acesso as solicitações de recompensas da plataforma, podendo interagir com o usuário",
                },
                {
                    permissao: "gesttor_suporte_filtro_avancado",
                    titulo: "Filtros Avançados no Suporte",
                    descricao: "Com esta permissão usuário tem acesso aos filtros avançados dos suportes na plataforma, podendo filtrar pela empresa, responsável ou solicitante",
                },
                {
                    permissao: "gesttor_caixa_entrada",
                    titulo: "Caixa de Entrada dos Suportes",
                    descricao: "Com esta permissão o usuário pode acessar a tela para visualizar os suportes que não possuem responsável definido.",
                },
            ]
        },
        {
            "Configurações": [
                {
                    permissao: "configuracao_acesso",
                    titulo: "Acesso às Configurações",
                    descricao: "Com esta permissão o usuário terá acesso ao menu de configurações",
                },
                {
                    permissao: "configuracao_empresa",
                    titulo: "Dados da Empresa",
                    descricao: "Com esta permissão o usuário poderá atualizar os dados da empresa",
                },
                {
                    permissao: "configuracao_assinatura",
                    titulo: "Assinaturas",
                    descricao: "Com esta permissão o usuário terá acesso às assinaturas da plataforma",
                },
                {
                    permissao: "configuracao_usuario",
                    titulo: "Usuários",
                    descricao: "Com esta permissão o usuário terá acesso ao submenu de usuários",
                },
                {
                    permissao: "configuracao_usuario_cadastrar",
                    titulo: "Cadastrar Usuário",
                    descricao: "Com esta permissão o usuário poderá cadastrar novos usuários",
                },
                {
                    permissao: "configuracao_usuario_atualizar",
                    titulo: "Atualizar Usuário",
                    descricao: "Com esta permissão o usuário poderá atualizar dados de usuários",
                },
                {
                    permissao: "configuracao_integracao",
                    titulo: "Integrações",
                    descricao: "Com esta permissão o usuário poderá gerenciar integrações",
                },
                {
                    permissao: "configuracao_grupos_permissao",
                    titulo: "Grupos e Permissões",
                    descricao: "Com esta permissão o usuário poderá gerenciar grupos e permissões",
                },
                {
                    permissao: "configuracao_centro",
                    titulo: "Centro de Resultados",
                    descricao: "Com esta permissão o usuário poderá gerenciar centros de custo",
                },
                {
                    permissao: "configuracao_plano_conta",
                    titulo: "Plano de Contas",
                    descricao: "Com esta permissão o usuário poderá gerenciar plano de contas",
                },
            ]
        }
    ];

    const abrirModalGrupo = (grupo?: GrupoLista) => {
        setGrupoSelecionado(grupo)
        modalExibir("ModalGrupo")
    }

    const fecharModalGrupo = () => {
        setGrupoSelecionado(undefined)

        modalExibir("")
    }
    
    const modulosContratados = useModulosContratados();

    const temModuloRecrutamento = modulosContratados.some((modulo) => modulo.nome === "Recrutamento");

    const temModuloProjetos = modulosContratados.some((modulo) => modulo.nome === "Projetos");

    const temModuloAtendimento = modulosContratados.some((modulo) => modulo.nome === "Atendimento");

    const temModuloDocumentos = modulosContratados.some((modulo) => modulo.nome === "Documentos");

    const isOrganizacaoHG =
        organizacaoLogada === process.env.REACT_APP_ORGANIZACAO_HG;

    const atualizarToggle = async (ativo: boolean, permissao: permissao) => {
        try {
            const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
            const permissoesAutorizadas = ['master', 'administrativo', 'configuracao_grupos_permissao']
            const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

            if(!temPermissao) return toast.warn("Você não tem permissão para atualizar a situação do Grupo.")
            setProcessando(true);

            const payload: any = {
                situacao: ativo ? "Ativa" : "Inativa",
                permissao: permissao?.permissao,
                idGrupo: criptografarDado(permissao.idGrupo.toString())
            };

            if (permissao.id) {
                payload.idPermissao = criptografarDado(permissao.id.toString());
            }

            const resposta = await atualizarPermissao(payload);

            if (resposta.status === 200) {
                toast.success("Permissão atualizada com sucesso!");
                atualizarDados();
            }
        } catch {
            toast.error("Erro ao atualizar as Permissões.");
        } finally {
            setProcessando(false);
        }
    };

    useEffect(() => {
        buscarGrupos()
    }, [atualizarInformacoes])

    return (
        <Permissoes permissoes={['master', 'administrativo', 'configuracao_grupos_permissao']}>
            <div className="paginaContainer">
                {nenhumResultado && <NenhumResultadoEncontrado />}
                {modal.nome === "ModalGrupo" && <ModalGrupo grupoSelecionado={grupoSelecionado} onClose={fecharModalGrupo} />}
                {modalSecundario.nome === "ModalTransferenciaGrupo" && grupoSelecionado && <ModalTransferenciaGrupo idGrupoAntigo={grupoSelecionado.id} />}
                <FiltrosDefault termo={titulo} onChangeTermo={(e) => setTitulo(e.target.value)} placeholder='Pesquise pelo nome' tipo={"Grupo"} situacao={situacao} onChangeSituacao={(e) => setSituacao(e.target.value)} onSubmit={buscarGrupos} listaSituacao={[{ nome: 'Todos', valor: '' }, { nome: 'Ativos', valor: 'Ativo' }, { nome: 'Inativos', valor: 'Inativo' }]} genero='masculino' isLoading={processando} acaoBtn={() => modalExibir("ModalGrupo")} />
                <section id="fundoContainerPagina">
                    <section id="tabelaListaContainer">
                        {grupos.map((grupo, index) => (
                            <details className="containerDetails" key={index}>
                                <summary className="summary">
                                    <span className="summaryHeader">
                                        <h3>{grupo.titulo}</h3>
                                        <p className="descricaoGrupo">
                                            {grupo.descricao}
                                        </p>
                                    </span>
                                    <span className="descricaoLinha">
                                        <DivSituacao cor={grupo.situacao.toLowerCase()} texto={grupo.situacao} />
                                        <button
                                            type="button"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                abrirModalGrupo(grupo);
                                            }}
                                            className="btnEditar"
                                        >
                                            <BiPencil size={18} />
                                        </button>
                                    </span>
                                </summary>
                                <section className="section_details">
                                    {permissoesFixas.map((topicoObj, index) => {
                                        const [topicoNome, permissoesDefault] = Object.entries(topicoObj)[0];

                                        if(topicoNome === "Gesttor" && !isOrganizacaoHG){
                                            return null
                                        }

                                        if(topicoNome === "Documentos" && !temModuloDocumentos){
                                            return null
                                        }

                                        if(topicoNome === "Atendimento" && !temModuloAtendimento){
                                            return null
                                        }

                                        if (topicoNome === "Recrutamento" && !temModuloRecrutamento) {
                                            return null;
                                        }
                                        
                                        if (topicoNome === "Projetos" && !temModuloProjetos) {
                                            return null;
                                        }

                                        return (
                                            <details key={index} className="containerSubDetails">
                                                <summary className="subSummary">{topicoNome}</summary>
                                                <section className="section_details">
                                                    {permissoesDefault.map((permissaoDefault: any, indexPermissao: any) => {
                                                        const permissaoGrupo = grupo.permissoes?.find(
                                                            (p) => p.permissao === permissaoDefault.permissao
                                                        );

                                                        if (permissaoDefault.permissao === "dashboard_banco_talentos" && !isOrganizacaoHG) {
                                                            return null;
                                                        }

                                                        if (permissaoDefault.permissao === "dashboard_processo_seletivo" && !temModuloRecrutamento) {
                                                            return null;
                                                        }
                                                        return (
                                                            <div key={indexPermissao} className="container_toggle">
                                                                <Toggle
                                                                    id={`${permissaoDefault.permissao}-${grupo.id}`}
                                                                    checked={() => permissaoGrupo?.situacao === "Ativa"}
                                                                    onChange={(e) => {
                                                                        const checked = e.target.checked;
                                                                        atualizarToggle(checked, {
                                                                            ...permissaoDefault,
                                                                            id: permissaoGrupo?.id,
                                                                            idGrupo: grupo.id,
                                                                        });
                                                                    }}
                                                                />
                                                                <div>
                                                                    <p><strong>{permissaoDefault.titulo}</strong></p>
                                                                    <small style={{ color: "#666" }}>{permissaoDefault.descricao}</small>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </section>
                                            </details>
                                        )
                                    })}
                                </section>
                            </details>
                        ))}
                    </section>
                </section>
            </div>
        </Permissoes>
    );
};

export default GruposPermissoes